// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Asthma Tracker Styles */

/* Main Container */
.asthma-tracker-container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #eaeaea;
}

/* Loading and Error States */
.loading-container,
.error-container,
.no-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  background-color: #f9f9f9;
  border-radius: 8px;
  font-size: 1.2rem;
  color: #666;
}

.error-container {
  color: #d32f2f;
  background-color: #ffebee;
}

/* Priority Unmet Need Selector */
.priority-selector-section {
  margin-bottom: 2rem;
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  border-left: 4px solid #4285f4;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.priority-selector-section h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.priority-selector {
  width: 100%;
}

.priority-select {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1em;
}

.priority-select:focus {
  outline: none;
  border-color: #4285f4;
  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
}

.priority-context {
  background-color: #e8f5e9;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-bottom: 1.5rem;
}

.priority-context p {
  margin: 0;
  color: #2e7d32;
  font-size: 0.95rem;
}

.priority-context .selected-percentage {
  margin-top: 0.5rem;
  font-size: 1.05rem;
  font-weight: 500;
  color: #1b5e20;
  border-top: 1px solid rgba(46, 125, 50, 0.2);
  padding-top: 0.5rem;
}

/* System Selector Section */
.system-selector-section {
  margin-bottom: 2rem;
}

.system-selector-section h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #444;
}

.system-selector {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.search-container {
  padding: 1rem;
  background-color: #f5f5f5;
  border-bottom: 1px solid #eaeaea;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.systems-list-header {
  display: flex;
  padding: 0.75rem 1rem;
  background-color: #f0f0f0;
  border-bottom: 1px solid #ddd;
  font-weight: 600;
}

.system-name-header {
  flex: 3 1;
}

.patient-count-header {
  flex: 1 1;
  text-align: right;
}

.systems-list {
  max-height: 300px;
  overflow-y: auto;
}

.system-item {
  display: flex;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
}

.system-item:hover {
  background-color: #f5f9ff;
}

.system-item.selected {
  background-color: #e3f2fd;
}

.system-name {
  flex: 3 1;
  font-weight: 500;
}

.patient-count {
  flex: 1 1;
  text-align: right;
  color: #666;
}

.no-results {
  padding: 2rem;
  text-align: center;
  color: #999;
}

/* View Selector Section - Removed */

/* Chart Container - Update to add space after view selector */
.chart-container {
  margin-top: 20px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Local, State, and National Views */
.local-view-container,
.state-view-container,
.national-view-container {
  /* Common styles for all views */
}

.chart-description {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #f5f5f5;
  border-radius: 6px;
  border-left: 3px solid #607d8b;
}

.chart-description p {
  margin: 0;
  font-size: 0.95rem;
  color: #455a64;
  line-height: 1.5;
}

/* Summary Sections */
.state-summary,
.national-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.summary-item {
  flex: 1 1;
  min-width: 200px;
  padding: 0.75rem;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.summary-label {
  display: block;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.25rem;
}

.summary-value {
  display: block;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
}

/* Selected System Context */
.selected-system-context {
  padding: 1rem;
  background-color: #e8f5e9;
  border-radius: 6px;
  margin-bottom: 1.5rem;
}

.selected-system-context p {
  margin: 0;
  font-size: 1rem;
  color: #2e7d32;
}

/* Top Systems Sections */
.top-systems-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 2rem;
}

.top-systems-section {
  flex: 1 1;
  min-width: 300px;
}

.top-systems-section h3 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: #333;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #eee;
}

.top-systems-list {
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.top-system-item {
  display: flex;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #eee;
}

.top-system-item.highlighted {
  background-color: #fff8e1;
}

.rank {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #333;
  font-weight: 600;
  border-radius: 50%;
  margin-right: 0.75rem;
}

.system-info {
  flex: 1 1;
}

.system-location {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.25rem;
}

.unmet-need-info,
.overlap-info {
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
}

.unmet-need-label,
.overlap-label {
  font-size: 0.85rem;
  color: #666;
  margin-right: 0.5rem;
}

.unmet-need-percentage {
  font-weight: 600;
  color: #d32f2f;
  padding: 0.1rem 0.4rem;
  background-color: #ffebee;
  border-radius: 4px;
}

.unmet-need-score,
.overlap-score {
  font-weight: 600;
  color: #1976d2;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .asthma-tracker-container {
    padding: 1rem;
  }
  
  .top-systems-container {
    flex-direction: column;
  }
  
  .summary-item {
    min-width: 100%;
  }
}

/* Treemap Styles */
.sites-treemap-container {
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  width: 100%;
}

.plans-treemap-container {
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  width: 100%;
}

.site-type-filter {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  font-size: 0.9rem;
}

.sites-treemap-container h3 {
  margin-top: 0;
  color: #2c3e50;
  font-weight: 600;
}

.plans-treemap-container h3 {
  margin-top: 0;
  color: #2c3e50;
  font-weight: 600;
}

.treemap-container {
  margin-top: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.sites-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.plans-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

/* Physicians Distribution Styles */
.physicians-container {
  margin: 30px 0;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.physicians-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.physicians-header h3 {
  margin: 0;
  font-size: 1.3rem;
  color: #333;
}

.site-count {
  font-size: 0.9rem;
  color: #666;
  background-color: #f0f0f0;
  padding: 5px 10px;
  border-radius: 4px;
}

.physicians-container h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
  font-size: 1.3rem;
}

.physician-site {
  font-size: 0.85rem;
  color: #666;
  margin-top: 2px;
}

.top-physicians-container {
  margin-top: 2rem;
}

.top-physicians-container h4 {
  margin-bottom: 1rem;
  color: #444;
  font-size: 1.1rem;
}

.top-physicians-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.physician-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background-color: #f9f9f9;
  border-radius: 6px;
  border-left: 4px solid #4caf50;
}

.physician-item .rank {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4caf50;
  color: white;
  font-weight: bold;
  border-radius: 50%;
  margin-right: 12px;
}

.physician-info {
  flex: 1 1;
}

.physician-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.25rem;
}

.physician-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}

.physician-specialty {
  color: #666;
  font-size: 0.9rem;
  font-style: italic;
}

.patient-count {
  font-size: 0.85rem;
  color: #777;
}

/* Updated Summary Card Styles */
.summary-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 1rem;
  min-width: 180px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.summary-title {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.summary-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.state-summary, .national-summary {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

/* Health System Profile Styles */
.system-profile-container {
  background-color: #f9fafb;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.system-profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
}

.system-profile-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

/* Individual stat items */
.stat-item {
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  border-radius: 6px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
}

.stat-label {
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 0.25rem;
}

/* Insurance mix stats */
.insurance-mix {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.insurance-type {
  text-align: center;
  padding: 0.5rem;
  flex: 1 1;
}

.insurance-value {
  font-size: 1.25rem;
  font-weight: 600;
}

.insurance-label {
  font-size: 0.75rem;
  color: #6b7280;
}

/* Comparison colors */
.text-red-500 {
  color: #ef4444;
}

.text-green-500 {
  color: #10b981;
}

/* Profile charts */
.profile-chart {
  background-color: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.profile-chart h4 {
  margin-top: 0;
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
}

/* Grid layout styles */
.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.p-4 {
  padding: 1rem;
}

.border-b {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #e5e7eb;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.shadow {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.bg-white {
  background-color: white;
}

/* Alignment classes */
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.ml-1 {
  margin-left: 0.25rem;
}

.ml-3 {
  margin-left: 0.75rem;
}

/* Text styling */
.text-lg {
  font-size: 1.125rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-3xl {
  font-size: 1.875rem;
}

.font-semibold {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.text-sm {
  font-size: 0.875rem;
}

.text-gray-600 {
  color: #4b5563;
}

/* Responsive adjustments */
@media (min-width: 768px) {
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  
  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .system-profile-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .system-profile-header h3 {
    margin-bottom: 1rem;
  }
  
  .stat-item {
    padding: 0.5rem;
  }
  
  .profile-chart {
    margin-bottom: 1rem;
  }
}

/* Adjust existing sections for better flow */
.physicians-container,
.sites-treemap-container,
.chart-container {
  margin-top: 2.5rem;
}

.physicians-container h3,
.sites-treemap-container h3,
.chart-container h3 {
  color: #333;
  font-size: 1.3rem;
  margin-top: 0;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f0f0f0;
}

/* View Content */
.view-content {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
}

/* Current View Heading */
.current-view-heading {
  margin: 20px 0;
  padding: 0 10px;
}

.current-view-heading h2 {
  font-size: 1.6rem;
  color: #333;
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
}

/* Color Legend for Unmet Needs Chart */
.color-legend {
  display: block;
  margin-top: 8px;
  font-size: 0.9rem;
}

.color-indicator {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 5px;
  margin-left: 10px;
  border-radius: 2px;
}

.color-indicator.red {
  background-color: rgba(255, 99, 132, 0.8);
}

.color-indicator.green {
  background-color: rgba(75, 192, 192, 0.8);
}

/* Comparison Tabs Styles */
.system-profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #f0f0f0;
}

.system-profile-header h3 {
  margin: 0;
  padding: 0;
  border-bottom: none;
}

.comparison-tabs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.comparison-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #666;
}

.tabs-container {
  display: flex;
  gap: 5px;
}

.comparison-tab {
  padding: 5px 10px;
  background-color: #f0f0f0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  color: #555;
  transition: all 0.2s ease;
}

.comparison-tab:hover {
  background-color: #e0e0e0;
}

.comparison-tab.active {
  background-color: #3f51b5;
  color: white;
}

@media (max-width: 768px) {
  .system-profile-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .comparison-tabs {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .tabs-container {
    width: 100%;
  }
  
  .comparison-tab {
    flex: 1 1;
    text-align: center;
  }
}

.tab-button {
  padding: 10px 20px;
  background-color: #e0e0e0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.tab-button:hover {
  background-color: #d0d0d0;
}

.tab-button.active {
  background-color: #3f51b5;
  color: white;
}

/* Enhanced styles for chart symbols */
.chart-symbol-legend {
  display: flex;
  align-items: center;
  margin-top: 10px;
  flex-wrap: wrap;
  gap: 15px;
}

.symbol-item {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.symbol {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  display: inline-block;
}

.symbol.triangle {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 18px solid #3f51b5;
}

.symbol.triangle.red {
  border-bottom-color: rgba(255, 99, 132, 1);
}

.symbol.triangle.green {
  border-bottom-color: rgba(75, 192, 192, 1);
}

.symbol.circle {
  border-radius: 50%;
  background-color: rgba(255, 152, 0, 1);
}

.symbol-label {
  font-size: 0.85rem;
  color: #666;
}

/* Profile cards for age and comorbidity charts */
.age-chart-card,
.comorbidity-chart-card {
  min-height: 300px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .chart-symbol-legend {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .symbol-item {
    margin-bottom: 8px;
  }
}

/* Hospital Lists Styles */
.hospital-lists-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 2rem;
}

.hospital-list-section {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
}

.hospital-list-section.full-width {
  width: 100%;
}

.hospital-list-section h3 {
  color: #333;
  font-size: 1.3rem;
  margin-top: 0;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f0f0f0;
}

.hospital-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.hospital-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-radius: 6px;
  background-color: #f9f9f9;
  transition: background-color 0.2s;
  position: relative;
}

.hospital-item:hover {
  background-color: #f0f0f0;
}

.hospital-item.highlighted {
  background-color: #edf5ff;
  border: 2px solid #4285f4;
  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.15);
  position: relative;
}

.hospital-item.highlighted::before {
  content: "Selected System";
  position: absolute;
  top: -10px;
  right: 10px;
  background-color: #4285f4;
  color: white;
  font-size: 0.75rem;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 500;
}

.hospital-item .rank {
  background-color: #4a6da7;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 15px;
}

.hospital-info {
  flex: 1 1;
}

.hospital-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.hospital-location {
  font-size: 0.9rem;
  color: #666;
}

.unmet-need-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 2rem;
}

.unmet-need-label {
  font-size: 0.9rem;
  color: #777;
}

.unmet-need-percentage {
  font-weight: 600;
  color: #d35151;
}

.patient-count {
  font-size: 0.9rem;
  color: #555;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .hospital-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .hospital-item .rank {
    position: absolute;
    top: 10px;
    left: 10px;
    margin-right: 0;
  }
  
  .hospital-info {
    margin-left: 40px;
    margin-bottom: 10px;
    width: 100%;
  }
  
  .unmet-need-info {
    margin-left: 40px;
    margin-bottom: 8px;
    width: 100%;
  }
  
  .patient-count {
    margin-left: 40px;
    width: 100%;
  }
}

/* Back button styles */
.back-button {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.2s;
  margin-bottom: 16px;
}

.back-button:hover {
  background-color: #e9e9e9;
}

/* System detail header */
.system-detail-header {
  margin-bottom: 24px;
}

.system-meta {
  margin-top: 8px;
  font-size: 16px;
  color: #555;
}

.patient-count-label {
  font-weight: 500;
}

.patient-count-value {
  font-weight: 600;
}

/* Selection instruction */
.selection-instruction {
  margin-bottom: 16px;
  color: #555;
  font-size: 16px;
}

/* Error container */
.error-container {
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 24px auto;
  max-width: 800px;
  text-align: center;
  color: #d32f2f;
  font-size: 16px;
}

.error-container button {
  margin-top: 16px;
}

/* Media Queries */
@media (max-width: 768px) {
  .system-selection-container,
  .system-detail-container,
  .system-metrics,
  .chart-container,
  .sites-treemap-container,
  .plans-treemap-container,
  .physicians-container,
  .unmet-needs-container,
  .exacerbation-container {
    padding: 0.75rem;
  }
  
  .system-detail-header h2,
  .current-view-heading h2,
  .sites-treemap-container h3,
  .plans-treemap-container h3,
  .physicians-container h3,
  .unmet-needs-container h3,
  .exacerbation-container h3 {
    font-size: 1.3rem;
  }

  /* ... existing code ... */
}

/* System Overview Layout */
.profile-summary {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.profile-summary .grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

@media (min-width: 768px) {
  .profile-summary .grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.stat-item {
  padding: 0.75rem;
  background-color: #f9fafb;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;
}

.stat-item:hover {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.25rem;
}

.stat-label {
  font-size: 0.875rem;
  color: #4b5563;
} `, "",{"version":3,"sources":["webpack://./src/pages/AsthmaTracker/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,mBAAmB;AACnB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;;;EAGE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yDAA2R;EAC3R,4BAA4B;EAC5B,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA,oCAAoC;;AAEpC,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,qCAAqC;AACrC;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;;EAEE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wEAAwE;EACxE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wEAAwE;EACxE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,6CAA6C;AAC7C;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,iDAAiD;AACjD;;EAEE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;;;;;;;;;IASE,gBAAgB;EAClB;;EAEA;;;;;;;IAOE,iBAAiB;EACnB;;EAEA,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* Asthma Tracker Styles */\n\n/* Main Container */\n.asthma-tracker-container {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 1.5rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #eaeaea;\n}\n\n/* Loading and Error States */\n.loading-container,\n.error-container,\n.no-data-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n.error-container {\n  color: #d32f2f;\n  background-color: #ffebee;\n}\n\n/* Priority Unmet Need Selector */\n.priority-selector-section {\n  margin-bottom: 2rem;\n  background-color: #f8f9fa;\n  padding: 1.5rem;\n  border-radius: 8px;\n  border-left: 4px solid #4285f4;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.priority-selector-section h2 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.priority-selector {\n  width: 100%;\n}\n\n.priority-select {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #333;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 1em;\n}\n\n.priority-select:focus {\n  outline: none;\n  border-color: #4285f4;\n  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);\n}\n\n.priority-context {\n  background-color: #e8f5e9;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  margin-bottom: 1.5rem;\n}\n\n.priority-context p {\n  margin: 0;\n  color: #2e7d32;\n  font-size: 0.95rem;\n}\n\n.priority-context .selected-percentage {\n  margin-top: 0.5rem;\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: #1b5e20;\n  border-top: 1px solid rgba(46, 125, 50, 0.2);\n  padding-top: 0.5rem;\n}\n\n/* System Selector Section */\n.system-selector-section {\n  margin-bottom: 2rem;\n}\n\n.system-selector-section h2 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #444;\n}\n\n.system-selector {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.search-container {\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.systems-list-header {\n  display: flex;\n  padding: 0.75rem 1rem;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #ddd;\n  font-weight: 600;\n}\n\n.system-name-header {\n  flex: 3;\n}\n\n.patient-count-header {\n  flex: 1;\n  text-align: right;\n}\n\n.systems-list {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.system-item {\n  display: flex;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.system-item:hover {\n  background-color: #f5f9ff;\n}\n\n.system-item.selected {\n  background-color: #e3f2fd;\n}\n\n.system-name {\n  flex: 3;\n  font-weight: 500;\n}\n\n.patient-count {\n  flex: 1;\n  text-align: right;\n  color: #666;\n}\n\n.no-results {\n  padding: 2rem;\n  text-align: center;\n  color: #999;\n}\n\n/* View Selector Section - Removed */\n\n/* Chart Container - Update to add space after view selector */\n.chart-container {\n  margin-top: 20px;\n  padding: 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Local, State, and National Views */\n.local-view-container,\n.state-view-container,\n.national-view-container {\n  /* Common styles for all views */\n}\n\n.chart-description {\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background-color: #f5f5f5;\n  border-radius: 6px;\n  border-left: 3px solid #607d8b;\n}\n\n.chart-description p {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #455a64;\n  line-height: 1.5;\n}\n\n/* Summary Sections */\n.state-summary,\n.national-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n}\n\n.summary-item {\n  flex: 1;\n  min-width: 200px;\n  padding: 0.75rem;\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.summary-label {\n  display: block;\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 0.25rem;\n}\n\n.summary-value {\n  display: block;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Selected System Context */\n.selected-system-context {\n  padding: 1rem;\n  background-color: #e8f5e9;\n  border-radius: 6px;\n  margin-bottom: 1.5rem;\n}\n\n.selected-system-context p {\n  margin: 0;\n  font-size: 1rem;\n  color: #2e7d32;\n}\n\n/* Top Systems Sections */\n.top-systems-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.top-systems-section {\n  flex: 1;\n  min-width: 300px;\n}\n\n.top-systems-section h3 {\n  font-size: 1.2rem;\n  margin-bottom: 1rem;\n  color: #333;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #eee;\n}\n\n.top-systems-list {\n  background-color: #fff;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.top-system-item {\n  display: flex;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #eee;\n}\n\n.top-system-item.highlighted {\n  background-color: #fff8e1;\n}\n\n.rank {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f0f0f0;\n  color: #333;\n  font-weight: 600;\n  border-radius: 50%;\n  margin-right: 0.75rem;\n}\n\n.system-info {\n  flex: 1;\n}\n\n.system-location {\n  font-size: 0.85rem;\n  color: #666;\n  margin-bottom: 0.25rem;\n}\n\n.unmet-need-info,\n.overlap-info {\n  display: flex;\n  align-items: center;\n  margin-top: 0.5rem;\n}\n\n.unmet-need-label,\n.overlap-label {\n  font-size: 0.85rem;\n  color: #666;\n  margin-right: 0.5rem;\n}\n\n.unmet-need-percentage {\n  font-weight: 600;\n  color: #d32f2f;\n  padding: 0.1rem 0.4rem;\n  background-color: #ffebee;\n  border-radius: 4px;\n}\n\n.unmet-need-score,\n.overlap-score {\n  font-weight: 600;\n  color: #1976d2;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .asthma-tracker-container {\n    padding: 1rem;\n  }\n  \n  .top-systems-container {\n    flex-direction: column;\n  }\n  \n  .summary-item {\n    min-width: 100%;\n  }\n}\n\n/* Treemap Styles */\n.sites-treemap-container {\n  margin-bottom: 2rem;\n  padding: 1rem;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  width: 100%;\n}\n\n.plans-treemap-container {\n  margin-bottom: 2rem;\n  padding: 1rem;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  width: 100%;\n}\n\n.site-type-filter {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n  font-size: 0.9rem;\n}\n\n.sites-treemap-container h3 {\n  margin-top: 0;\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.plans-treemap-container h3 {\n  margin-top: 0;\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.treemap-container {\n  margin-top: 1rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.sites-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n.plans-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n/* Physicians Distribution Styles */\n.physicians-container {\n  margin: 30px 0;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.physicians-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.physicians-header h3 {\n  margin: 0;\n  font-size: 1.3rem;\n  color: #333;\n}\n\n.site-count {\n  font-size: 0.9rem;\n  color: #666;\n  background-color: #f0f0f0;\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n.physicians-container h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #333;\n  font-size: 1.3rem;\n}\n\n.physician-site {\n  font-size: 0.85rem;\n  color: #666;\n  margin-top: 2px;\n}\n\n.top-physicians-container {\n  margin-top: 2rem;\n}\n\n.top-physicians-container h4 {\n  margin-bottom: 1rem;\n  color: #444;\n  font-size: 1.1rem;\n}\n\n.top-physicians-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.physician-item {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  border-left: 4px solid #4caf50;\n}\n\n.physician-item .rank {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #4caf50;\n  color: white;\n  font-weight: bold;\n  border-radius: 50%;\n  margin-right: 12px;\n}\n\n.physician-info {\n  flex: 1;\n}\n\n.physician-name {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 0.25rem;\n}\n\n.physician-details {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.25rem;\n}\n\n.physician-specialty {\n  color: #666;\n  font-size: 0.9rem;\n  font-style: italic;\n}\n\n.patient-count {\n  font-size: 0.85rem;\n  color: #777;\n}\n\n/* Updated Summary Card Styles */\n.summary-card {\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 1rem;\n  min-width: 180px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.summary-title {\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n}\n\n.summary-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.state-summary, .national-summary {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 2rem;\n}\n\n/* Health System Profile Styles */\n.system-profile-container {\n  background-color: #f9fafb;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.system-profile-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.system-profile-header h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0;\n}\n\n/* Individual stat items */\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  padding: 0.75rem;\n  border-radius: 6px;\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n}\n\n.stat-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #111827;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n}\n\n/* Insurance mix stats */\n.insurance-mix {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n\n.insurance-type {\n  text-align: center;\n  padding: 0.5rem;\n  flex: 1;\n}\n\n.insurance-value {\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.insurance-label {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n/* Comparison colors */\n.text-red-500 {\n  color: #ef4444;\n}\n\n.text-green-500 {\n  color: #10b981;\n}\n\n/* Profile charts */\n.profile-chart {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  height: 100%;\n}\n\n.profile-chart h4 {\n  margin-top: 0;\n  margin-bottom: 0.75rem;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n/* Grid layout styles */\n.grid {\n  display: grid;\n}\n\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.gap-3 {\n  gap: 0.75rem;\n}\n\n.gap-4 {\n  gap: 1rem;\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem;\n}\n\n.mb-4 {\n  margin-bottom: 1rem;\n}\n\n.mb-6 {\n  margin-bottom: 1.5rem;\n}\n\n.p-4 {\n  padding: 1rem;\n}\n\n.border-b {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: #e5e7eb;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem;\n}\n\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n\n.shadow {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.bg-white {\n  background-color: white;\n}\n\n/* Alignment classes */\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.ml-1 {\n  margin-left: 0.25rem;\n}\n\n.ml-3 {\n  margin-left: 0.75rem;\n}\n\n/* Text styling */\n.text-lg {\n  font-size: 1.125rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n}\n\n.text-gray-600 {\n  color: #4b5563;\n}\n\n/* Responsive adjustments */\n@media (min-width: 768px) {\n  .md\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  \n  .md\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 767px) {\n  .system-profile-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .system-profile-header h3 {\n    margin-bottom: 1rem;\n  }\n  \n  .stat-item {\n    padding: 0.5rem;\n  }\n  \n  .profile-chart {\n    margin-bottom: 1rem;\n  }\n}\n\n/* Adjust existing sections for better flow */\n.physicians-container,\n.sites-treemap-container,\n.chart-container {\n  margin-top: 2.5rem;\n}\n\n.physicians-container h3,\n.sites-treemap-container h3,\n.chart-container h3 {\n  color: #333;\n  font-size: 1.3rem;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n/* View Content */\n.view-content {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  padding: 1.5rem;\n}\n\n/* Current View Heading */\n.current-view-heading {\n  margin: 20px 0;\n  padding: 0 10px;\n}\n\n.current-view-heading h2 {\n  font-size: 1.6rem;\n  color: #333;\n  margin: 0;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n/* Color Legend for Unmet Needs Chart */\n.color-legend {\n  display: block;\n  margin-top: 8px;\n  font-size: 0.9rem;\n}\n\n.color-indicator {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-right: 5px;\n  margin-left: 10px;\n  border-radius: 2px;\n}\n\n.color-indicator.red {\n  background-color: rgba(255, 99, 132, 0.8);\n}\n\n.color-indicator.green {\n  background-color: rgba(75, 192, 192, 0.8);\n}\n\n/* Comparison Tabs Styles */\n.system-profile-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.system-profile-header h3 {\n  margin: 0;\n  padding: 0;\n  border-bottom: none;\n}\n\n.comparison-tabs {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.comparison-label {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #666;\n}\n\n.tabs-container {\n  display: flex;\n  gap: 5px;\n}\n\n.comparison-tab {\n  padding: 5px 10px;\n  background-color: #f0f0f0;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #555;\n  transition: all 0.2s ease;\n}\n\n.comparison-tab:hover {\n  background-color: #e0e0e0;\n}\n\n.comparison-tab.active {\n  background-color: #3f51b5;\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .system-profile-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  \n  .comparison-tabs {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .tabs-container {\n    width: 100%;\n  }\n  \n  .comparison-tab {\n    flex: 1;\n    text-align: center;\n  }\n}\n\n.tab-button {\n  padding: 10px 20px;\n  background-color: #e0e0e0;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.tab-button:hover {\n  background-color: #d0d0d0;\n}\n\n.tab-button.active {\n  background-color: #3f51b5;\n  color: white;\n}\n\n/* Enhanced styles for chart symbols */\n.chart-symbol-legend {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.symbol-item {\n  display: flex;\n  align-items: center;\n  margin-right: 15px;\n}\n\n.symbol {\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  display: inline-block;\n}\n\n.symbol.triangle {\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 18px solid #3f51b5;\n}\n\n.symbol.triangle.red {\n  border-bottom-color: rgba(255, 99, 132, 1);\n}\n\n.symbol.triangle.green {\n  border-bottom-color: rgba(75, 192, 192, 1);\n}\n\n.symbol.circle {\n  border-radius: 50%;\n  background-color: rgba(255, 152, 0, 1);\n}\n\n.symbol-label {\n  font-size: 0.85rem;\n  color: #666;\n}\n\n/* Profile cards for age and comorbidity charts */\n.age-chart-card,\n.comorbidity-chart-card {\n  min-height: 300px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .chart-symbol-legend {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .symbol-item {\n    margin-bottom: 8px;\n  }\n}\n\n/* Hospital Lists Styles */\n.hospital-lists-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.hospital-list-section {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  padding: 1.5rem;\n}\n\n.hospital-list-section.full-width {\n  width: 100%;\n}\n\n.hospital-list-section h3 {\n  color: #333;\n  font-size: 1.3rem;\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.hospital-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.hospital-item {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  border-radius: 6px;\n  background-color: #f9f9f9;\n  transition: background-color 0.2s;\n  position: relative;\n}\n\n.hospital-item:hover {\n  background-color: #f0f0f0;\n}\n\n.hospital-item.highlighted {\n  background-color: #edf5ff;\n  border: 2px solid #4285f4;\n  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.15);\n  position: relative;\n}\n\n.hospital-item.highlighted::before {\n  content: \"Selected System\";\n  position: absolute;\n  top: -10px;\n  right: 10px;\n  background-color: #4285f4;\n  color: white;\n  font-size: 0.75rem;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-weight: 500;\n}\n\n.hospital-item .rank {\n  background-color: #4a6da7;\n  color: white;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  margin-right: 15px;\n}\n\n.hospital-info {\n  flex: 1;\n}\n\n.hospital-name {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.hospital-location {\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.unmet-need-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-right: 2rem;\n}\n\n.unmet-need-label {\n  font-size: 0.9rem;\n  color: #777;\n}\n\n.unmet-need-percentage {\n  font-weight: 600;\n  color: #d35151;\n}\n\n.patient-count {\n  font-size: 0.9rem;\n  color: #555;\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .hospital-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .hospital-item .rank {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    margin-right: 0;\n  }\n  \n  .hospital-info {\n    margin-left: 40px;\n    margin-bottom: 10px;\n    width: 100%;\n  }\n  \n  .unmet-need-info {\n    margin-left: 40px;\n    margin-bottom: 8px;\n    width: 100%;\n  }\n  \n  .patient-count {\n    margin-left: 40px;\n    width: 100%;\n  }\n}\n\n/* Back button styles */\n.back-button {\n  background-color: #f5f5f5;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.2s;\n  margin-bottom: 16px;\n}\n\n.back-button:hover {\n  background-color: #e9e9e9;\n}\n\n/* System detail header */\n.system-detail-header {\n  margin-bottom: 24px;\n}\n\n.system-meta {\n  margin-top: 8px;\n  font-size: 16px;\n  color: #555;\n}\n\n.patient-count-label {\n  font-weight: 500;\n}\n\n.patient-count-value {\n  font-weight: 600;\n}\n\n/* Selection instruction */\n.selection-instruction {\n  margin-bottom: 16px;\n  color: #555;\n  font-size: 16px;\n}\n\n/* Error container */\n.error-container {\n  padding: 24px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin: 24px auto;\n  max-width: 800px;\n  text-align: center;\n  color: #d32f2f;\n  font-size: 16px;\n}\n\n.error-container button {\n  margin-top: 16px;\n}\n\n/* Media Queries */\n@media (max-width: 768px) {\n  .system-selection-container,\n  .system-detail-container,\n  .system-metrics,\n  .chart-container,\n  .sites-treemap-container,\n  .plans-treemap-container,\n  .physicians-container,\n  .unmet-needs-container,\n  .exacerbation-container {\n    padding: 0.75rem;\n  }\n  \n  .system-detail-header h2,\n  .current-view-heading h2,\n  .sites-treemap-container h3,\n  .plans-treemap-container h3,\n  .physicians-container h3,\n  .unmet-needs-container h3,\n  .exacerbation-container h3 {\n    font-size: 1.3rem;\n  }\n\n  /* ... existing code ... */\n}\n\n/* System Overview Layout */\n.profile-summary {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.profile-summary .grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n@media (min-width: 768px) {\n  .profile-summary .grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.stat-item {\n  padding: 0.75rem;\n  background-color: #f9fafb;\n  border-radius: 0.375rem;\n  border: 1px solid #e5e7eb;\n  transition: all 0.2s ease;\n}\n\n.stat-item:hover {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.stat-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 0.25rem;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  color: #4b5563;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
